import {Component, Input} from '@angular/core';
import {FormField} from 'hateoas-navigator';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'app-input-field',
  template: `<mat-form-field class="cmp-full-width">
  <input matInput [placeholder]="field.getTitle()" [formControl]="control" [type]="type">
</mat-form-field>
`,
  styles: [``, `.cmp-full-width{width:100%}`]
})
export class InputFieldComponent {
  @Input()
  field: FormField;

  @Input()
  control: FormControl;

  @Input()
  type = 'text';
}
